import 'babel-polyfill';
import 'roc-package-web-app-react/app/default/client';



/** WEBPACK FOOTER **
 ** /src/shared/client-entry.js
 **/